/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BulkManualExportDto = {
    /**
     * Payout calendar month (YYYY-MM)
     */
    payoutMonth: string;
    /**
     * Corporate bank CSV format
     */
    format?: BulkManualExportDto.format;
};
export namespace BulkManualExportDto {
    /**
     * Corporate bank CSV format
     */
    export enum format {
        ENBD = 'ENBD',
        FAB = 'FAB',
        MASHREQ = 'MASHREQ',
        RAKBANK_UAE = 'RAKBANK_UAE',
        GENERIC = 'GENERIC',
    }
}

